import { CompanyFunction, CompanyOrContactRelation, CompanyType, ContactType } from '@condo/domain';
import { toTitleCase } from '@condo/formatters';
import i18n from '@/shared/i18n/instance';
import type { TabularRelation } from '../model';

export const TabularRelations: TabularRelation[] = [
    {
        label: 'Sourcing',
        items: [
            {
                relationName: CompanyOrContactRelation.Seller,
                types: { contact: [ContactType.Seller], company: [CompanyType.Seller], default: 'contact' },
                img: 'contact_seller.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.Realtor,
                types: {
                    contact: [ContactType.RealEstateAgent],
                    company: [CompanyType.Realtor],
                    default: 'company',
                },
                img: 'company_realtor.jpeg',
            },
        ],
    },
    {
        label: 'Purchasing',
        items: [
            {
                relationName: CompanyOrContactRelation.Notary,
                types: { contact: [ContactType.Notary], company: [CompanyType.Notary], default: 'company' },
                img: 'company_notary.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.Bank,
                types: { contact: [ContactType.Banker], company: [CompanyType.Bank], default: 'company' },
                img: 'company_bank.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.DistrictCourt,
                types: { contact: [], company: [CompanyType.DistrictCourt], default: 'company' },
                img: 'company_district_court.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.ConstructionAuthority,
                types: {
                    contact: [],
                    company: [CompanyType.ConstructionAuthority],
                    default: 'company',
                },
                img: 'company_construction_authority.jpeg',
            },
        ],
    },
    {
        label: 'External',
        items: [
            {
                relationName: CompanyOrContactRelation.EnergyEfficiencyConsultant,
                types: {
                    contact: [ContactType.EnergyEfficiencyConsultant],
                    company: [],
                    default: 'contact',
                },
                img: 'company_bank.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.TechnicalDDExpert,
                types: { contact: [ContactType.TechnicalDDExpert], company: [], default: 'contact' },
                img: 'company_bank.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.LegalDDExpert,
                types: { contact: [ContactType.LegalDDExpert], company: [], default: 'contact' },
                img: 'company_bank.jpeg',
            },
            {
                relationName: CompanyOrContactRelation.TaxDDConsultant,
                types: { contact: [ContactType.TaxDDConsultant], company: [], default: 'contact' },
                img: '',
            },
            {
                relationName: CompanyOrContactRelation.AssetPartner,
                types: { contact: [ContactType.AssetPartner], company: [], default: 'contact' },
                img: '',
            },
        ],
    },
];

export const getAllAllowedContactTypes = (): ContactType[] => TabularRelations.flatMap(relation => relation.items.flatMap(item => item.types.contact));

export const getContactTitle = (relationName: CompanyOrContactRelation | CompanyFunction): string => {
    switch (relationName) {
        case CompanyOrContactRelation.TechnicalDDExpert:
            return 'Technical DD Expert';
        case CompanyOrContactRelation.LegalDDExpert:
            return 'Legal DD Expert';
        case CompanyFunction.PLRenovation:
            return 'PL Renovation';
        case CompanyFunction.TLRenovation:
            return 'TL Renovation';
        case CompanyFunction.DealCaptain:
            return i18n.t('companyFunctions.dealCaptain', { ns: 'contacts', defaultValue: 'Deal Captain' });
        default:
            return toTitleCase(String(relationName));
    }
};
